import api from '@/logic/api'
import { relaunchApi } from '@/logic/relaunchApi'

export default {
  findUsers: (query, checkMaxConcurrentGames = 1) => api.get(`/users/search?q=${encodeURIComponent(query)}&checkMaxGames=${checkMaxConcurrentGames}`),
  // Public user profile (frontend API)
  getPublicProfile: (userId) => relaunchApi.get(`/users/${encodeURIComponent(userId)}/profile`),
  // Authenticated user's profile (relaunch API)
  getOwnProfile: (userId) => relaunchApi.get(`/users/${encodeURIComponent(userId)}/profile`),
  // Update profile entries for a user (relaunch API)
  updateProfileEntries: (userId, profileEntries) => relaunchApi.post(`/users/${encodeURIComponent(userId)}/profile`, {
    profile_entries: profileEntries,
  }),
  // Create a chat access request for a specific user (frontend API)
  requestChatAccess: (userId) => relaunchApi.post('/chat/access-requests', { target_user_id: userId }),
  checkChatAccess: (userId) => relaunchApi.get('/chat/access-requests/status', { target_user_id: userId }),
}
